import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    display: 'inline-flex',
    background: '#506E87',
    borderRadius: '999px',
    padding: '4px',
    gap: '4px',
  },
  option: {
    border: 'none',
    background: 'transparent',
    color: '#E7EEF5',
    borderRadius: '999px',
    padding: '8px 16px',
    cursor: 'pointer',
    textTransform: 'uppercase',
    fontWeight: 700,
    letterSpacing: '0.02em',
    textDecoration: 'none',
    transition: 'all 180ms ease',
  },
  active: {
    background: '#19989B',
    color: '#fff',
  },
}));

const SegmentedToggle = ({ options, value, onChange, ariaLabel, useNavLinks }) => {
  const classes = useStyles();

  return (
    <div className={classes.root} role="tablist" aria-label={ariaLabel}>
      {options.map(option => {
        const active = option.value === value;
        const className = `${classes.option} ${active ? classes.active : ''}`;

        if (useNavLinks && option.to) {
          return (
            <NavLink
              key={option.value}
              to={option.to}
              role="tab"
              aria-selected={active}
              className={className}
              onClick={() => onChange(option.value)}>
              {option.label}
            </NavLink>
          );
        }

        return (
          <button
            key={option.value}
            type="button"
            role="tab"
            aria-selected={active}
            className={className}
            onClick={() => onChange(option.value)}>
            {option.label}
          </button>
        );
      })}
    </div>
  );
};

SegmentedToggle.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    to: PropTypes.string,
  })).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string,
  useNavLinks: PropTypes.bool,
};

SegmentedToggle.defaultProps = {
  ariaLabel: 'Content mode',
  useNavLinks: false,
};

export default SegmentedToggle;
